"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui/");
var _contexts = require("../../contexts");
var _styles = _interopRequireDefault(require("./styles"));
var _References = _interopRequireDefault(require("../References"));
var _books = _interopRequireDefault(require("../../services/contents/books"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */
function ReferencesPopover() {
  var {
    uuid,
    applicationToken,
    sessionToken,
    setBookFile
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    showingReferencesPopover,
    toggleReferencesPopover,
    isDesktopView
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var classes = (0, _styles.default)();
  var HASH = 'references';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [reference, setReference] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        toggleReferencesPopover(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, toggleReferencesPopover]);
  (0, _react.useEffect)(() => {
    if (showingReferencesPopover) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [showingReferencesPopover]);
  var anchorOrigin = isDesktopView ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var transformOrigin = isDesktopView ? {
    vertical: 'top',
    horizontal: 'left'
  } : {
    vertical: 'top',
    horizontal: 'center'
  };
  var spaceStyle = isDesktopView ? {
    top: 90,
    left: 105
  } : {
    top: 40,
    right: 16
  };
  var handleClosePopover = () => {
    toggleReferencesPopover(false);
  };
  (0, _react.useEffect)(() => {
    function fetchEpub() {
      return _fetchEpub.apply(this, arguments);
    }
    function _fetchEpub() {
      _fetchEpub = _asyncToGenerator(function* () {
        try {
          var response = yield (0, _books.default)(applicationToken, sessionToken).getBook(uuid);
          if (!response.ok) {
            var errors = yield response.json();
            throw errors;
          }
          var book = yield response.json();
          setBookFile(book);
          setReference(book.abnt);
        } catch (err) {
          /* eslint-disable-next-line */
          console.error(err);
        }
      });
      return _fetchEpub.apply(this, arguments);
    }
    fetchEpub();
  }, [applicationToken, sessionToken, uuid, setBookFile]);
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: showingReferencesPopover,
    onClose: handleClosePopover,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: {
      paper: classes.rootPopoverReference
    },
    style: spaceStyle
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title,
    variant: "h6"
  }, "Refer\xEAncia"), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_References.default, {
    reference: reference
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider,
    style: {
      margin: '12px 0 0 0'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bottom
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    color: "primary",
    onClick: handleClosePopover
  }, "FECHAR")));
}
var _default = exports.default = ReferencesPopover;